import { createFileRoute } from '@tanstack/react-router';

import { AgencyConnections } from '@/components/agency/connections/agency-connections';
import { connectionsSearchSchema } from '@/components/connectors/connections-search';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/connections')({
  validateSearch: connectionsSearchSchema,
  loader: () => loadNamespaces('agency', 'settings'),
  staticData: {
    title: 'route.agency_connections.title',
  },
  component: AgencyConnectionsRoute,
});

function AgencyConnectionsRoute(): React.ReactElement {
  return <AgencyConnections search={Route.useSearch()} />;
}
